import "./spinner.css";

const Spinner = () => {
  return (
    <div className="spinner-overlay">
      <div className="box">
        <div className="spinner"></div>
      </div>
    </div>
  );
};
export default Spinner;
